const config = {
  hostname: process.env.REACT_APP_BACKEND_HOST,
  internal_backend_host: process.env.REACT_APP_INTERNAL_BACKEND_HOST,
  internal_frontend_host: process.env.REACT_APP_INTERNAL_FRONTEND_HOST,
  port: process.env.REACT_APP_BACKEND_PORT,
  secure: !!process.env.REACT_APP_BACKEND_SECURE,
  version: '1',
}

export default config;